import ServiceClient from '../ServiceClient'

export type QueryReacoesRequest = Partial<{
    dataInicio: string
    dataFim: string
    statusBulaValue: number
    gravidadeValue: number
    buscaGeralText: string
    buscaReacaoText: string
    buscaMedicamentoText: string
}>

export type QueryReacoesResponse = {
    resumo: Resumo
    grade: {
        titulo: {
            qtdeNotificacoes: number,
            periodoDeAnalise: string
        },
        linhas: GradeLinha[]
    }
}

export type GradeReacao = {
    nome: string
    pt: string
    llt: string
    obtito: boolean
    statusConferencia: number
    statusGravidade: number
    gravidadeCount: number
    gravidadeCountMax: number
}

export type GradeLinha = {
    id: string
    nome: string
    nomeQuimico: string
    paciente: string
    atc: string
    qtdeReacoes: number
    obtito?: boolean
    statusConferencia: number
    statusForaDaBula: number
    statusNaBula: number
    statusGravidade: number
    qtdeCasos: number
    periodoNotificacaoLinha1: string
    periodoNotificacaoLinha2: string
    mostraDetalheReacoes: boolean
    reacoes: { id: string; left: GradeReacao; right: GradeReacao }[]
}

export type ReacaoCard = {
    id: string
    medicamento: string
    sintoma: string
    frequencia: string
    confiabilidade: number
    qtdeCasos: number
}

export type Resumo = {
    qtdeNotificacoes: {
        valor: number
        reacoes: number
    }
    qtdeForaDeBula: {
        valor: number
        reacoes: number
    }
    qtdeNaoVerificada: number
    qtdePendentesVerificacao: number
}

export default async (request: QueryReacoesRequest) => {
    const url = ServiceClient.newUrl('/api/v1/notificacoes/reacoes')
    request.dataInicio && (url.searchParams.append('data-inicio', request.dataInicio))
    request.dataFim && (url.searchParams.append('data-fim', request.dataFim))
    request.statusBulaValue && (url.searchParams.append('status', `${request.statusBulaValue}`))
    request.gravidadeValue && (url.searchParams.append('gravidade', `${request.gravidadeValue}`))
    request.buscaGeralText && (url.searchParams.append('geral', request.buscaGeralText))
    request.buscaReacaoText && (url.searchParams.append('reacao', request.buscaReacaoText))
    request.buscaMedicamentoText && (url.searchParams.append('medicamento', request.buscaMedicamentoText))
    return await ServiceClient.authGet(url) as QueryReacoesResponse
}